// 生成随机串的指定字符集
const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

/**
 * 从指定字符集中拼接固定长度的随机字符串
 * @param {number} length
 * @returns {string}
 */
const randomString = (length, chars) => {
  let randomString = '';
  for (let i = length; i > 0; --i) {
    randomString += chars[Math.floor(Math.random() * chars.length)];
  }
  return randomString;
};

/**
 * X-Tone-Requestld 请求头
 * @returns {string}
 */
export const xToneRequestld = () => {
  const str = randomString(22, chars);
  const curTime = Math.trunc((Date.now() - 1000 * 60 * 5) * 0.001);
  return `${str}_${curTime}`;
};
